
import React, {useContext, useEffect, useRef} from "react";
import classnames from "classnames";
// reactstrap components
import {
    Input,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
    Row,
    Col,
    CardHeader,Card, CardBody, Button, FormGroup
} from "reactstrap";
import { UserLoginContext } from "../../context/UserLoginContext";
import { CollectionsContext } from "../../context/CollectionsContext";
import {useHistory} from "react-router-dom";
import SweetAlert from "react-bootstrap-sweetalert";
import NotificationAlert from "react-notification-alert";
import rest from "../../API/api";
import { authenticatedFetch } from "../../services/authService";

const AddCohortCollection = () => {
    // eslint-disable-next-line
    const [collectionsState, setCollectionsState] = useContext(CollectionsContext);
    const [userState, setUserState] = useContext(UserLoginContext);
    const [title, settitle] = React.useState(collectionsState.cohortCollection.Title);
    const [titleState, settitleState] = React.useState("");
    const [titleFocus, settitleFocus] = React.useState("");
    // eslint-disable-next-line
    const [description, setdescription] = React.useState(collectionsState.cohortCollection.Description);
    const [descriptionState, setdescriptionState] = React.useState("");
    const [descriptionFocus, setdescriptionFocus] = React.useState("");

    const [alert, setalert] = React.useState(null);
    const notificationAlertRef = useRef(null);
    const history = useHistory();

    const stateFunctions = {
        settitleState: (value) => settitleState(value),
        settitle: (value) => settitle(value),
        setdescriptionState: (value) => setdescriptionState(value),
        setdescription: (value) => setdescription(value),
    };

    const notify = (type, message) => {
        const options = {
            place: "tc",
            message: <div>{message}</div>,
            type: type,
            icon: "tim-icons icon-bell-55",
            autoDismiss: 5,
        };
        notificationAlertRef.current.notificationAlert(options);
    };

    useEffect(() => {
        //console.log(questionsState.theQuestion);
        settitleState("has-success");
        setdescriptionState("has-success");
    }, []);

    // function that verifies if a string has a given length or not
    const verifyLength = (value, length) => {
        if (value.length >= length) {
            return true;
        }
        return false;
    };
    // function that verifies if value contains only numbers
    const verifyNumber = (value) => {
        var numberRex = new RegExp("^[0-9]+$");
        if (numberRex.test(value)) {
            return true;
        }
        return false;

    };
    const change = (event, stateName, type, stateNameEqualTo, maxValue) => {
        switch (type) {
            case "length":
                if (verifyLength(event.target.value, stateNameEqualTo)) {
                    stateFunctions["set" + stateName + "State"]("has-success");
                } else {
                    stateFunctions["set" + stateName + "State"]("has-danger");
                }
                stateFunctions["set" + stateName](event.target.value);
                break;
            case "number":
                if (verifyNumber(event.target.value, stateNameEqualTo)) {
                    stateFunctions["set" + stateName + "State"]("has-success");
                } else {
                    stateFunctions["set" + stateName + "State"]("has-danger");
                }
                stateFunctions["set" + stateName](event.target.value);
                break;
            default:
                break;
        }

    };
    /*eslint-disable-next-line*/
    const isValidated = () => {
        if (
            titleState === "has-success" &&
            descriptionState === "has-success"
        ) {
            return true;
        } else {
            if (titleState !== "has-success") {
                settitleState("has-danger");
            }
            if (descriptionState !== "has-success") {
                setdescriptionState("has-danger");
            }
            return false;
        }
    };

    const _editCollectionAlert = async () => {
        //console.log("email to delete:" + email);
        //debugger;
        setalert(
            <SweetAlert
                warning
                showCancel
                confirmBtnText="Yes, save it!"
                confirmBtnBsStyle="info"
                cancelBtnBsStyle="default"
                title="Are you sure?"
                style={{display: "block"}}
                onConfirm={() => {
                    _edit_collection();
                    setalert(null);
                }}
                onCancel={() =>  {
                    setalert(null);
                }}
            >
                Are you sure you want to save this collection?
            </SweetAlert>
        );
    };
    const _edit_collection = async (id) => {
        try {
            var tempURL = rest.cohortCollections + '/' + collectionsState.cohortCollection._id;
            const response = await authenticatedFetch(tempURL, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    Title: title,
                    Description: description,
                }),
            });

            if (!response.ok) {
                const errorData = await response.json();
                console.error('Update failed:', errorData);
                throw new Error(errorData.message || 'Failed to update collection');
            }

            const addCollectionJSON = await response.json();
            setCollectionsState((prevcollectionsState) => ({
                ...prevcollectionsState,
                cohortCollections: addCollectionJSON
            }));

            notify("success", "Collection has been updated successfully!");
            setTimeout(() => {
                history.push("/admin/cohortcollections");
            }, 1000);
        } catch (error) {
            console.error('Error updating collection:', error);
            notify("danger", error.message || 'Failed to update collection.');
        }
    };

    if (userState.status) {
      return (
          <>
              <div className="rna-container">
                  <NotificationAlert ref={notificationAlertRef} />
              </div>
              <div className="content">
                  <Col md={8} className="ml-auto mr-auto">
                      <h2 className="text-center">Edit a Cohort Collection</h2>
                  </Col>

                  <Card>
                      <CardHeader>Collection Information:</CardHeader>
                      <CardBody>
                          <Row>
                              <Col md={5} mdOffset={1}>
                                  <FormGroup className={`has-label ${titleState}`}>
                                      <label>Collection Title *</label>
                                      <Input
                                          name="title"
                                          type="text"
                                          value={title}
                                          onChange={(e) => change(e, "title", "length",1)}
                                      />
                                      {titleState === "has-danger" ? (
                                          <label className="error">
                                              Please enter a valid collection title.
                                          </label>
                                      ) : null}
                                  </FormGroup>
                              </Col>
                              <Col md={3} mdOffset={1}>
                                  <FormGroup className={`has-label ${descriptionState}`}>
                                      <label>Collection Description *</label>
                                      <Input
                                          name="description"
                                          type="text"
                                          value={description}
                                          onChange={(e) => change(e, "description", "length",1)}
                                      />
                                      {descriptionState === "has-danger" ? (
                                          <label className="error">
                                              Please enter a valid description.
                                          </label>
                                      ) : null}
                                  </FormGroup>
                              </Col>
                          </Row>
                      </CardBody>
                  </Card>
                  <Card>
                  <CardBody>
                          <Row>
                              <Col md={1} mdOffset={1} xs={5} xsOffset={1}>
                                  <Button color="info" className="animation-on-hover" onClick={ async () => {
                                      if(isValidated()) {
                                          await _editCollectionAlert();
                                      }
                                  }}>Save
                                  </Button>
                              </Col>
                              <Col md={1} mdOffset={1} xs={5} xsOffset={1}>
                                  <Button color="danger" className="animation-on-hover" onClick={ async () => {
                                          let tURL = "/admin/cohortcollections";
                                          await history.push(tURL);
                                  }}>Cancel
                                  </Button>
                              </Col>
                          </Row>
                      </CardBody>
                  </Card>
                  {alert}
              </div>
          </>
      );
    }
    else {
        //alert("You must be logged in and have an active subscription to access this page!");
        history.push("/admin/dashboard");
        return(null);
    }
};
export default AddCohortCollection;
